<script setup>
</script>

<template>

  <v-alert
      color="#C51162"
      icon="mdi-alert"
      theme="dark"
      border
  >
    You do not have permission to view this page!
  </v-alert>

</template>

<style scoped>

</style>